'use strict';

exports.__esModule = true;
var COUNTRY = exports.COUNTRY = {
  LOAD: 'COUNTRY_LOAD',
  LOAD_LIST: 'COUNTRY_LOAD_LIST',
  LOAD_LIST_DONE: 'COUNTRY_LOAD_LIST_DONE',
  LOAD_DONE: 'COUNTRY_LOAD_DONE',
  LOAD_LIST_FAIL: 'COUNTRY_LOAD_LIST_FAIL',
  LOAD_FAIL: 'COUNTRY_LOAD_FAIL'
};

var COUNTRIES = exports.COUNTRIES = {
  COUNTRIES: {
    LOADING: 'COUNTRIES_LOADING',
    SUCCEEDED: 'COUNTRIES_SUCCEEDED',
    FAILED: 'COUNTRIES_FAILED'
  }
};

var loadCountries = exports.loadCountries = function loadCountries() {
  return {
    type: COUNTRIES.COUNTRIES.LOADING
  };
};

var loadCountriesSuccess = exports.loadCountriesSuccess = function loadCountriesSuccess(payload) {
  return {
    type: COUNTRIES.COUNTRIES.SUCCEEDED,
    payload: payload
  };
};

var loadCountriesFailed = exports.loadCountriesFailed = function loadCountriesFailed() {
  return {
    type: COUNTRIES.COUNTRIES.FAILED
  };
};

var loadCountry = exports.loadCountry = function loadCountry() {
  return {
    type: COUNTRY.LOAD
  };
};

var loadCountryList = exports.loadCountryList = function loadCountryList() {
  return {
    type: COUNTRY.LOAD_LIST
  };
};

var loadCountryDone = exports.loadCountryDone = function loadCountryDone(countries) {
  return {
    type: COUNTRY.LOAD_DONE,
    countries: countries
  };
};

var loadCountryListDone = exports.loadCountryListDone = function loadCountryListDone(countries) {
  return {
    type: COUNTRY.LOAD_LIST_DONE,
    countries: countries
  };
};

var loadCountryFail = exports.loadCountryFail = function loadCountryFail(err) {
  return {
    type: COUNTRY.LOAD_FAIL,
    err: err
  };
};

var loadCountryListFail = exports.loadCountryListFail = function loadCountryListFail(err) {
  return {
    type: COUNTRY.LOAD_LIST_FAIL,
    err: err
  };
};